export class FileUploadUtils {

    static toInitFileMap = (uid, url) => {
        return {
            uid: uid,
            name: url,
            url: url,
            thumbUrl: url,
            status: 'done',
        }
    }

    static toFileUrlMap = (fileGroup, singleFile) => {
        if (!fileGroup) {
            return {}
        }
        const result = {}
        for (let key of Object.keys(fileGroup)) {
            const files = fileGroup[key]
            if (!files || !files.length) {
                result[key] = null
                continue
            }

            const urls = files.map(f => getFileUrl(f))
            if (singleFile) {
                result[key] = urls[0]
            } else {
                result[key] = urls
            }
        }
        return result
    }

    static toFileUrlJsonMap = (fileGroup) => {
        const files = FileUploadUtils.toFileUrlMap(fileGroup, false)
        const result = {}
        for (let key of Object.keys(files)) {
            const file = files[key]
            if (file && file.length) {
                result[key] = JSON.stringify(file)
            } else {
                result[key] = null
            }
        }
        return result
    }
}


const getFileUrl = (file) => {
    if (file.status === "done") {
        if (file.response) {
            return file.response.data
        }
        return file.url
    }
    if (file.status === "error") {
        throw Error("文件：" + file.name + " 上传失败，请移除或重新上传。")
    }
    if (file.status === "uploading") {
        throw Error("文件上传中，请稍候。")
    }
}